import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import Main from 'layouts/Main';
import Main from 'views/layouts/Main/Main';
import Box from '@mui/material/Box';

import SimContainer from 'components/SimContainer';
import SimLeaderQuote from 'components/SimLeaderQuote';

import {
	ClientReviews,
	FeaturedServiceSlider,
	FeaturedCommunitySessions,
	Footer,
	Banner,
	Services,
	WhyChooseUs
} from './components';
import SimPolygon from 'components/svg/shapes/SimPolygon';


const HomePage = () => {
	const theme = useTheme();
	return (
		<Main>
			<Box
				position={'relative'}
				sx={{
					backgroundColor: theme.palette.primary.main,
					marginTop: 0
				}}>
				<Box paddingX={{ xs: 2, sm: 4, lg: 16 }} paddingBottom={4}>
					<Banner />
				</Box>

				<Box top={'-50px'}>
					<SimPolygon />
				</Box>
			</Box>

			<SimContainer>
				<WhyChooseUs />
			</SimContainer>

			<Box bgcolor={'secondary.main'} marginTop={{ xs: '20vw', sm: '20vw', md: '5vw' }}>
				<SimContainer>
					<SimLeaderQuote />
				</SimContainer>
			</Box>

			<Box sx={{ pb: 2, mb: 2 }}>
				<SimContainer>
					<FeaturedCommunitySessions />
				</SimContainer>
			</Box>

			<Box
				id='dividerFinal'
				height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
				marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
				<Box
					height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
					component={'svg'}
					preserveAspectRatio='none'
					xmlns='http://www.w3.org/2000/svg'
					x='0px'
					y='0px'
					viewBox='0 0 1920 100.1'
					sx={{
						marginBottom: -1,
						width: 1
					}}>
					<path fill={theme.palette.background.transparentDefault} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
				</Box>
			</Box>

			<Box
				sx={{
					bgcolor: 'background.transparentDefault',
					paddingTop: 2,
					paddingLeft: 4,
					paddingRight: 4
				}}>
				<SimContainer>
					<Services />
				</SimContainer>
			</Box>

			<Box
				id='dividerFinal'
				height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
				bgcolor={theme.palette.background.transparentDefault}>
				<Box
					height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
					component={'svg'}
					preserveAspectRatio='none'
					xmlns='http://www.w3.org/2000/svg'
					x='0px'
					y='0px'
					viewBox='0 0 1920 100.1'
					sx={{
						marginBottom: -1,
						width: 1
					}}
					bgcolor={theme.palette.background.transparentDefault}>
					<path fill={theme.palette.background.default} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
				</Box>
			</Box>

			<Box paddingBottom={2} marginBottom={2}>
				<SimContainer>
					<FeaturedServiceSlider />
				</SimContainer>
			</Box>

			<Box
				id='dividerFinal'
				height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
				paddingTop={{ sm: '10vw', md: '5vw' }}
				bgcolor={theme.palette.background.default}>
				<Box
					height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
					component={'svg'}
					preserveAspectRatio='none'
					xmlns='http://www.w3.org/2000/svg'
					x='0px'
					y='0px'
					viewBox='0 0 1920 100.1'
					sx={{
						marginBottom: -1,
						width: 1
					}}
					bgcolor={theme.palette.background.default}>
					<path fill={theme.palette.background.transparentDefault} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
				</Box>
			</Box>

			<Box
				paddingY={3}
				sx={{
					bgcolor: 'background.transparentDefault',
					paddingTop: 2,
					paddingLeft: 4,
					paddingRight: 4
				}}>
				<SimContainer>
					<ClientReviews />
					<Box paddingTop={12}>
						<Footer />
					</Box>
				</SimContainer>
			</Box>
		</Main>
	);
};

export default HomePage;








